'use client';

import { ChatMessage } from '@chewy/chat-library-common';
import { formatTimeWithLowercaseAMPM } from '@chewy/chat-library-common/tools/dates';
import styles from './AgentJoinedIndicator.module.scss';
import AgentCard from './AgentCard';

export interface AgentJoinedMessage {
  /** Timestamp when agent joined */
  timestamp: string;
  /** Agent information */
  agent: {
    displayName: string;
    /** Team name (defaults to "Customer Care Team") */
    teamName?: string;
    agentUserId?: string;
  };
}

export interface AgentJoinedIndicatorProps {
  /** The widget data from structured message */
  data?: AgentJoinedMessage | AgentJoinedMessage[];
  /** The message from structured message */
  message?: ChatMessage;
}

export default function AgentJoinedIndicator({ data, message }: AgentJoinedIndicatorProps) {
  // Extract the first item if data is an array
  const joinedData = Array.isArray(data) ? data[0] : data;

  const agent = joinedData?.agent;
  const agentName = agent?.displayName ?? '';
  const timestamp = message?.responseTimestamp ?? '';
  const formattedTime = formatTimeWithLowercaseAMPM(timestamp);

  return (
    <div className={styles.container}>
      <span className={styles.text}>{agentName} joined the chat at {formattedTime}</span>
      <AgentCard
        data={{
          agentName,
          teamName: agent?.teamName,
          agentUserId: agent?.agentUserId,
        }}
      />
    </div>
  );
}
